import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#ce5a26',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#ce5a26',
      // dark: will be calculated from palette.secondary.main,
      //   contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  overrides: {
    MuiAppBar: {
      colorSecondary: {
        backgroundColor: () => {
          const stage = String(process.env.REACT_APP_BUILD_STAGE).trim().toLowerCase();
          const isDev = (stage.indexOf('dev') !== -1)

          // return green if we are in dev stage
          // return orange if we are not in dev stage
          return ( !isDev ? '#ce5a26' : '#26CE5A' );
        }
      }
    }
  }
});

export default theme;
